import React from 'react';
import {
  DataTable,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  SkeletonText,
  TableSelectAll,
  TableSelectRow,
  TableCell
} from 'carbon-components-react';
import { isObject } from 'lodash';

interface Props {
  rowData: any[];
  headerData: any[];
  isLoading?: boolean;
  selectedRowHandler?: Function;
  size?: string;
  onClickHeader?: Function;
  sortDirection?: string;
  sortingHeader?: string;
  selectedRowRef: React.RefObject<any>;
  setSelectedRowCount: React.Dispatch<React.SetStateAction<number>>;
}

export const ListDataTable: React.FC<Props> = ({
  headerData,
  rowData,
  size = 'normal',
  isLoading = false,
  selectedRowHandler,
  onClickHeader,
  sortDirection,
  sortingHeader,
  selectedRowRef,
  setSelectedRowCount
}: any) => {
  return (
    <DataTable
      rows={rowData}
      headers={headerData}
      size={size}
      render={({
        rows,
        headers,
        getHeaderProps,
        getSelectionProps,
        selectedRows
      }: any) => {
        selectedRowRef.current = selectedRows.map((item: any) => item.id);
        setSelectedRowCount(selectedRows.length);
        return (
          <TableContainer>
            <Table size={size} className="data-table--wrapper">
              <TableHead>
                <TableRow>
                  {headers.map((header: any) =>
                    header?.isCheckbox ? (
                      <TableSelectAll
                        key={header.key}
                        {...getSelectionProps()}
                      />
                    ) : (
                      <TableHeader
                        key={header.key}
                        {...getHeaderProps({
                          header,
                          isSortable: header?.isSortable
                        })}
                        isSortHeader={sortingHeader === header.key}
                        sortDirection={sortDirection}
                        onClick={() => onClickHeader(header.key)}
                      >
                        <div
                          className={`header-text ${
                            header.className ? header.className : ''
                          }`}
                        >
                          {header.header}
                        </div>
                      </TableHeader>
                    )
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading && headerData
                  ? headerData.map((item: any) => {
                      return (
                        <TableRow key={item.key}>
                          {headerData.map((i: any) => (
                            <td key={`s_${i.key}`}>
                              <SkeletonText />
                            </td>
                          ))}
                        </TableRow>
                      );
                    })
                  : rows.map((row: any) => {
                      return (
                        <TableRow
                          key={row.id}
                          onClick={() =>
                            selectedRowHandler && selectedRowHandler(row)
                          }
                        >
                          {row.cells.map((cell: any) => {
                            const {
                              info: { header }
                            } = cell;
                            const key = `${row.id}-${header}`;

                            return header === 'isReprocess' ? (
                              <TableSelectRow
                                key={key}
                                {...getSelectionProps({ row })}
                              />
                            ) : (
                              <TableCell key={key} className={`cell-${header}`}>
                                {isObject(cell.value)
                                  ? Object.values(cell.value).map(
                                      (item: any, i: any): any => {
                                        const itemKey = `${key}-${i}`;

                                        return item.noPara ? (
                                          <div key={itemKey}>{item.value}</div>
                                        ) : (
                                          <p key={itemKey}>{item}</p>
                                        );
                                      }
                                    )
                                  : cell.value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
              </TableBody>
            </Table>
          </TableContainer>
        );
      }}
    />
  );
};

export default React.memo(ListDataTable);
